var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2644 14.9226L35.255 14.8851L29.9957 1.52103C29.7613 0.766345 29.0629 0.246033 28.2707 0.246033H6.95192C6.15504 0.246033 5.44723 0.77572 5.22223 1.53978L0.305039 14.7679L0.290977 14.8007L0.281601 14.8382C0.220664 15.0679 0.201914 15.3023 0.234726 15.532C0.230039 15.607 0.225352 15.682 0.225352 15.757V32.9085C0.226591 33.664 0.527256 34.3882 1.06147 34.9224C1.59568 35.4566 2.31987 35.7573 3.07535 35.7585H32.4754C34.0457 35.7585 35.3254 34.4788 35.33 32.9085V15.757C35.33 15.696 35.33 15.6351 35.3254 15.5835C35.3441 15.3538 35.3254 15.1335 35.2644 14.9226ZM21.3988 12.907L21.3847 13.6429C21.3472 15.7476 19.8941 17.1632 17.7707 17.1632C16.7347 17.1632 15.8441 16.8304 15.2019 16.1976C14.5597 15.5648 14.2082 14.6835 14.1894 13.6429L14.1754 12.907H4.52848L8.25504 3.84603H26.9675L30.7972 12.907H21.3988ZM3.82066 16.507H11.1941C12.3332 19.1835 14.7566 20.7632 17.7754 20.7632C19.355 20.7632 20.8222 20.3226 22.0082 19.4882C23.0488 18.757 23.8597 17.7351 24.3847 16.507H31.7207V32.1585H3.82066V16.507Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropZone);
export default __webpack_public_path__ + "static/media/drop-zone.c81baa3067d4c759b667b36dc1a51561.svg";
export { ForwardRef as ReactComponent };